import user from './reducers/user'
import filters from './reducers/filters/index'
import mapBounds from './reducers/mapBounds'
import asideInfo from './reducers/asideInfo'
import ready from './reducers/ready'

export const reducerList = {
  user: user,
  filters: filters,
  mapBounds: mapBounds,
  asideInfo: asideInfo,
  ready: ready
}

export default reducerList
